<template>
    <div>
        <review-user :review="review" class="mb-3"/>

        <h5 v-if="headline" class="text-truncate">{{ headline }}</h5>
        <p class="text-wrap-pre-line">{{ displayReview }}</p>

        <a href="#" @click.prevent="displayFullReview">Show more</a>

        <template v-if="uiStore.isMobile">
            <peek v-if="fullReviewVisible" :open="fullReviewOpen" @close="closeFullReview">
                <template #header>
                    {{ headline || this.review.reviewerName }}
                </template>
                <template #default>
                    <review-user :review="review" class="mb-3"/>

                    <p class="text-wrap-pre-line" v-if="review.publicComments">{{ review.publicComments }}</p>

                    <hr />
                    <review-detail-stars :review="review"/>
                </template>
            </peek>
        </template>
        <template v-else>
            <modal v-if="fullReviewVisible" :open="fullReviewOpen" size="lg" @close="closeFullReview">
                <template #header>
                    {{ headline || this.review.reviewerName }}
                </template>
                <template #default>
                    <review-user :review="review" class="mb-3"/>

                    <p class="text-wrap-pre-line" v-if="review.publicComments">{{ review.publicComments }}</p>
                    
                    <hr />
                    <review-detail-stars :review="review"/>
                </template>
            </modal>
        </template>
    </div>
</template>

<script type="text/javascript">
    import ReviewDetailStars from '@/components/Content/Public/Properties/Reviews/DetailStars.vue';
    import ReviewUser from '@/components/Content/Public/Properties/Reviews/User.vue';
    import CommonComponents from '@/components/Common.vue';

    import ApiObject from '@/classes/ApiObject.js';

    import { UseUIStore } from '@/store/UI.js';

    export default {

        components: {
            ReviewDetailStars,
            ReviewUser,
            ...CommonComponents,
        },

        setup() {
            return {
                uiStore: UseUIStore(),
            };
        },

        data() {
            return {
                fullReviewOpen: true,
                fullReviewVisible: false,
            };
        },

        props: {
            review: {
                type: ApiObject,
                required: true,
            },
        },

        computed: {
            maxLength() {
                if (this.uiStore.isMobile) {
                    return 175;
                }
                else if (this.uiStore.isTablet) {
                    return 150;
                }
                return 125;
            },


            displayReview() {
                if (
                    (this.review) &&
                    (this.review.publicComments) &&
                    (this.review.publicComments.length > this.maxLength)
                ) {
                    let useReview = this.review.publicComments.replace(/[\n\r]+/g, ' ');
                    let pos = useReview.indexOf(' ', this.maxLength);
                    if (pos == -1) pos = this.maxLength;

                    return useReview.substring(0, pos).trim()+'...';
                }
                else if (
                    (this.review) &&
                    (this.review.publicComments)
                ) {
                    return this.review.publicComments;
                }
                return null;
            },

            headline() {
                if (
                    (this.review) && 
                    (this.review.headline) &&
                    (this.review.headline != 'none')
                ) {
                    return this.review.headline;
                }
                return null;
            },
        },

        methods: {
            displayFullReview() {
                this.fullReviewOpen = true;
                this.fullReviewVisible = true;
            },

            closeFullReview() {
                this.fullReviewVisible = false;
                this.fullReviewOpen = true;
            },
        },
    };

</script>
